import React, { useMemo } from 'react';
import { Box, Flex, Heading, Link, Text } from '@chakra-ui/react';
import { QuizBtn } from './QuizBtn';
import { SdgCategoryHeader } from './SdgCategoryHeader';
import { SdgImageContainer } from './SdgImageContainer';
import { formSdgCategories, useResponsive } from '../utils';
import contentJson from '../utils/content.json';
import { SdgCategory } from '#core/SdgQuiz/types';

const content: any = contentJson;

export type InfoPageProps = {
  handleNext: () => void;
};

export const InfoPage = ({ handleNext }: InfoPageProps) => {
  const isMobileScreen = useResponsive();

  const sdgCategories: SdgCategory[] = useMemo(
    () => formSdgCategories(content),
    [],
  );

  return (
    <Flex flexDir="column" alignItems="center">
      <Flex flexDir="column" alignItems="center" maxW="28rem">
        <Heading
          as="h1"
          textAlign="center"
          my={5}
          fontSize={isMobileScreen ? 'xl' : '4xl'}
        >
          {content.startPage.title}
        </Heading>
        <Text fontSize={isMobileScreen ? 'sm' : 'md'}>
          {content.startPage.firstParagraph.firstPart}
          <Link color="blue" href="https://sdgs.un.org/goals" target="_blank">
            {content.startPage.firstParagraph.secondPart}
          </Link>
        </Text>

        <Text fontSize={isMobileScreen ? 'sm' : 'md'} mt={5}>
          {content.startPage.secondParagraph}
        </Text>
        <QuizBtn onClick={handleNext}>Take the quiz</QuizBtn>
      </Flex>

      <Flex
        flexDir="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
      >
        {sdgCategories.map((sdgCategory: SdgCategory) => (
          <Box key={sdgCategory.categoryTitle} width="100%">
            <SdgCategoryHeader
              title={`${sdgCategory.categoryTitle} (${sdgCategory.numberOfSdgsPerCategory})`}
              backgroundColor="#3A3A3A"
              color="white"
            />

            <Flex
              width="100%"
              maxW="50rem"
              justifyContent="space-evenly"
              flexWrap="wrap"
            >
              {(isMobileScreen
                ? sdgCategory.imgSpritePositionsMobile
                : sdgCategory.imgSpritePositionsDesktop
              ).map((imgSpritePosition: string) => (
                <Box my={3} key={imgSpritePosition}>
                  <SdgImageContainer
                    bgPosition={imgSpritePosition}
                    bgSize={
                      isMobileScreen
                        ? content.imgContainerSizes.imgSizeMobileLarge
                        : content.imgContainerSizes.imgSizeDesktop
                    }
                    imgWidth={
                      isMobileScreen
                        ? content.imgContainerSizes.imgSideMobileLarge
                        : content.imgContainerSizes.imgSideDesktop
                    }
                    imgHeight={
                      isMobileScreen
                        ? content.imgContainerSizes.imgSideMobileLarge
                        : content.imgContainerSizes.imgSideDesktop
                    }
                  />
                </Box>
              ))}
            </Flex>
          </Box>
        ))}

        <QuizBtn onClick={handleNext}>Take the quiz</QuizBtn>
      </Flex>
    </Flex>
  );
};
